var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('notifications',{attrs:{"classes":"my-notifi","width":"350","duration":6000,"position":"left bottom"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }